define('cart_promocode_notifications.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('cart_promocode_notifications', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return " ";
},"useData":true}, 'extensions/UnlockCommerce/APCO_Updated_Theme/23.1.3/', 'extensions/UnlockCommerce/APCO_Updated_Theme/23.1.3/', Handlebars);
});